import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'borrowing',
    component: () => import('@/views/borrowing/index.vue')
  },
  {
    path: '/companyProfile',
    name: 'CompanyProfile',
    component: () => import('@/views/companyProfile/index.vue')
  },
  {
    path: '/serviceTab',
    name: 'ServiceTab',
    component: () => import('@/views/serviceTab/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
